import { render, staticRenderFns } from "./footer-config.vue?vue&type=template&id=04b3f56a&scoped=true"
import script from "./footer-config.vue?vue&type=script&lang=js"
export * from "./footer-config.vue?vue&type=script&lang=js"
import style0 from "./footer-config.vue?vue&type=style&index=0&id=04b3f56a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3f56a",
  null
  
)

export default component.exports